import {
  CommonModule,
  DatePipe,
  NgFor,
  NgIf,
  UpperCasePipe,
} from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'day-report-card',
  templateUrl: './day-report-card.component.html',
  styleUrls: ['./day-report-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgIf, NgFor, DatePipe, UpperCasePipe],
})
export class DayReportCardComponent {
  @Input() dayReport: any;
}
